import { MONTHS_SHORT_NAMES } from "../../../../../constants/dates";
import {
  IGetHiringsData,
  SearchHiringRequestsPerYearAndMonth,
} from "../../../../../services/ClientsDashboardServices.dto";
import {
  ChartData,
  ChartItem,
  MonthlyHiringRequestWithYear,
  Row,
} from "../../clients-dashboard-types";

const sortYears = (data: IGetHiringsData, sortDesc?: boolean) => {
  const sortedYears = data.searchHiringRequestsPerYearAndMonth.sort((a, b) => {
    if (sortDesc) return parseInt(b.year) - parseInt(a.year);
    return parseInt(a.year) - parseInt(b.year);
  });
  return sortedYears;
};

const sortMonths = (year: SearchHiringRequestsPerYearAndMonth, sortDesc?: boolean) => {
  return year.monthlyHiringRequests.sort((a, b) => {
    if (sortDesc) return parseInt(b.month) - parseInt(a.month);
    return parseInt(a.month) - parseInt(b.month);
  });
};

const getMonthsArray = (years: SearchHiringRequestsPerYearAndMonth[], isRatio?: boolean) => {
  const monthsArray = years.reduce((acc: MonthlyHiringRequestWithYear[], year) => {
    // se añade el dato del año a cada mes para utilizar su label en el eje
    const sortedMonths = sortMonths(year, isRatio).map((month) => {
      return { ...month, year: year.year };
    });
    return [...acc, ...sortedMonths];
  }, []);
  return monthsArray;
};

export const getHiringsChartData = (
  data: IGetHiringsData,
  isRatio?: boolean,
  sortDesc?: boolean
): ChartData => {
  const newData: ChartData = [];

  const sortedYears = sortYears(data, sortDesc);
  const monthsArray = getMonthsArray(sortedYears, sortDesc);

  monthsArray.forEach((month) => {
    const newDataItem: ChartItem = {
      month: MONTHS_SHORT_NAMES[month.month],
      year: month.year,
    };
    month.hiringRequestsPerBusinessLine.forEach((product) => {
      if (isRatio) {
        newDataItem[`Solicitudes ${product.businessLine}`] = product.hiringRequestsCount;
        newDataItem[`Pólizas ${product.businessLine}`] = product.policies;
      } else {
        newDataItem[product.businessLine] = product.hiringRequestsCount;
      }
    });
    newData.push(newDataItem);
  });

  return newData;
};

export const getTableData = (data: IGetHiringsData, isRatio?: boolean) => {
  const headRow: Row = { className: "", cells: [{ className: "fix-column", value: "Periodo" }] };
  const bodyRows: Row[] = [];
  const footerRow: Row = {
    className: "",
    cells: [{ className: "fix-column", value: "Total general" }],
  };

  data.overallHiringRequestsResults.hiringRequestsPerBusinessLine.forEach((product) => {
    headRow.cells.push({
      className: "",
      value: `${isRatio ? "" : "Suma de "}Solicitudes ${product.businessLine}`,
    });
    footerRow.cells.push({ className: "number", value: product.hiringRequestsCount });
    if (isRatio) {
      headRow.cells.push({ className: "", value: `Pólizas ${product.businessLine}` });
      footerRow.cells.push({ className: "number", value: product.policies });
    }
  });
  if (!isRatio) {
    headRow.cells.push({ className: "", value: "Suma de Total Solicitudes" });
    footerRow.cells.push({
      className: "number",
      value: data.overallHiringRequestsResults.totalHiringRequests,
    });
  }

  const sortedYears = sortYears(data);

  sortedYears.forEach((year) => {
    const yearRow: Row = {
      className: "year",
      cells: [{ className: "fix-column", value: year.year, contractActionList: [`${year.year}`] }],
    };
    year.yearlyHiringRequests.hiringRequestsPerBusinessLine.forEach((product) => {
      const newCell = { className: "number", value: product.hiringRequestsCount };
      yearRow.cells.push(newCell);
      if (isRatio) {
        yearRow.cells.push({ className: "number", value: product.policies });
      }
    });
    if (!isRatio) {
      yearRow.cells.push({ className: "number", value: year.yearlyHiringRequests.yearTotalCount });
    }
    bodyRows.push(yearRow);

    const monthsRows: Row[] = [];
    sortMonths(year).forEach((month) => {
      const monthRow: Row = {
        className: "month",
        cells: [{ className: "fix-column", value: MONTHS_SHORT_NAMES[month.month] }],
        contractByList: [`${year.year}`],
      };
      month.hiringRequestsPerBusinessLine.forEach((product) => {
        const newCell = { className: "number", value: product.hiringRequestsCount };
        monthRow.cells.push(newCell);
        if (isRatio) {
          monthRow.cells.push({ className: "number", value: product.policies });
        }
      });
      if (!isRatio) {
        monthRow.cells.push({ className: "number", value: month.monthTotalCount });
      }
      monthsRows.push(monthRow);
    });
    bodyRows.push(...monthsRows);
  });

  return {
    headRow,
    bodyRows,
    footerRow,
  };
};
